<template>
    <div class="list-item">
        <div class="list-item-left">
            <div class="list-item-name" v-if="data.type === '现金券'">
                <div style="font-size: 20px">{{"¥" + data.rebate/100}}</div>
<!--                <div style="font-size: 11px">满399可用</div>-->
            </div>
            <img :src="img" alt="" class="img-card">
        </div>

        <div class="list-item-divider"></div>

        <div class="list-item-right">
            <div class="list-item-title">
                <div class="list-item-type">{{data.type}}</div>
                <strong>{{data.name}}</strong>
            </div>
            <div class="list-item-content">核销码：{{data.code}}</div>
            <div class="list-item-time">有效期：{{data.timeStr}}</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ListItem",

        props: {
            data: {}
        },

        computed: {
            img() {
                if (this.data.type === "现金券") {
                    return require("../../../assets/card/img-use.png")
                }
                else {
                    return require("../../../assets/card/WechatIMG3111.png")
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "page";
    @import "color";

    .list-item {
        margin: 10px auto;
        display: flex;

        >div {
            border-radius: 10px;
            padding: 10px;
            background: white;
            box-sizing: border-box;
        }

        .list-item-left {
            position: relative;
            color: white;
            .img-card {
                width: 85px;
                height: 75px;
            }
            .list-item-name {
                text-align: center;
                position: absolute;
                top: 24px;
                right: 18px;
            }
        }

        .list-item-divider {
            margin-top: 10px;
            margin-bottom: 10px;
            padding: 0;
            border: #cccccc 1px dotted ;
        }

        .list-item-right {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: start;
            width: 100%;
            box-sizing: border-box;
            padding-left: 20px;
            .list-item-title {
                display: flex;
            }
            .list-item-type {
                padding: 0 5px;
                color: white;
                background: #8EC674;
                font-size: 13px;
                margin-right: 10px;
                min-width: 40px;
                height: 22px;
            }
            .list-item-content {
                color: $fontColor-6;
                font-size: 13px;
            }
            .list-item-time {
                color: $fontColor-9;
                font-size: 13px;
            }
        }
    }
</style>